import { render, staticRenderFns } from "./Datebox.vue?vue&type=template&id=4a6c563c&lang=pug"
import script from "./Datebox.vue?vue&type=script&lang=js"
export * from "./Datebox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports